<div class="modal-content">
    @if (data.title) {
        <div class="modal-header">
            <h2 class="modal-title flex-fill text-center">{{ data.title }}</h2>
            <button
                type="button"
                class="btn-close"
                aria-label="Close"
                [disabled]="submitProcessing()"
                (click)="dialogRef.close(false)"
            ></button>
        </div>
    }
    @if (data.message) {
        <div class="modal-body">
            @if (isMessageArray) {
                @for (paragraph of messageArray; track $index) {
                    <p>{{ paragraph }}</p>
                }
            } @else {
                <p>{{ data.message }}</p>
            }
        </div>
    }
    <div class="modal-footer">
        @if (data.denyActionText) {
            <button
                type="button"
                class="btn btn-link btn-min-width"
                [disabled]="submitProcessing()"
                (click)="dialogRef.close(false)"
            >
                {{ data.denyActionText }}
            </button>
        }
        <button
            type="button"
            [class]="customBtnClass"
            [disabled]="submitProcessing()"
            [attr.aria-label]="submitProcessing() ? 'Processing' : data.confirmActionText"
            (click)="onConfirmClick()"
        >
            @if (submitProcessing()) {
                <output class="spinner-border spinner-border-sm me-1">
                    <span class="visually-hidden">Processing</span>
                </output>
                Processing...
            } @else {
                {{ data.confirmActionText }}
            }
        </button>
    </div>
</div>
